// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RateTranslation_wrapper__kgw_N","title":"RateTranslation_title__5gLEB","flex":"RateTranslation_flex__CkPfk"};